export default {
  tcpaHistory: [],
  status: {}
};